import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import jwt_decode from "jwt-decode";
import { AuthService } from '../services/auth.service';


@Injectable({
  providedIn: 'root'
})


export class LandingRedirectGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) { }

  canActivate(): boolean {
    const userType = this.authService.getUserType();
    const vendorID = this.authService.getVendorID();
    const vendorIDString = vendorID?.toString(); // safe if vendorID is null/undefined

  //  alert(vendorIDString)

    //Need to default it here.
    if (userType === 4) {   
      this.router.navigate([`/vendor/${vendorIDString}`]);
      return false; // Cancel current route
    }


    return true; // Allow default landing
  }
}
